(function() {
	'use strict';
	angular.module('app.setup')
		.service('customerOrderStatusCategoryService', customerOrderStatusCategoryService);

	customerOrderStatusCategoryService.$inject = ['$http', 'URLS'];
	function customerOrderStatusCategoryService($http, URLS) {
		return {
			addCustomerOrderStatusCategory: addCustomerOrderStatusCategory,
			updateCustomerOrderStatusCategory: updateCustomerOrderStatusCategory
		};

		function addCustomerOrderStatusCategory(customerOrderStatusCategory) {
			return $http.post(URLS.host + String.format(URLS.customerOrderStatusCategories, globalConfig.customer.id), customerOrderStatusCategory)
				.then(addCustomerOrderStatusCategorySuccess, handleError);

			function addCustomerOrderStatusCategorySuccess(response) {
				return 'Customer Order Status Category created successfully';
			}
		}

		function updateCustomerOrderStatusCategory(customerOrderStatusCategory, lastModified) {
			return $http.put(URLS.host + String.format(URLS.customerOrderStatusCategories, globalConfig.customer.id), customerOrderStatusCategory, {headers: {'If-Unmodified-Since': lastModified}})
				.then(updateCustomerOrderStatusCategorySuccess, updateCustomerOrderStatusCategoryFailure);

			function updateCustomerOrderStatusCategorySuccess(response) {
				return response;
			}

			function updateCustomerOrderStatusCategoryFailure(response) {
				return response;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 409) {
				return error.data.error;
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
